import React from 'react';
import './footer.css'

import LinkedIn from "../../assets/social-icons/Linkedin.png"
import Instagram from "../../assets/social-icons/Instagram.png"
import footer from './footer.png';

function Footer() {
    return (
        <div className="footer">
            <div className="footer-content">
                <div className="title">
                    Stacks<span className="logo-span">.ps</span>
                </div>
                <div className="footer-email">team@oppotrain.com</div>
                <div className="social-icons-bar">
                      <a 
                        href="https://www.linkedin.com/company/oppotrain/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        aria-label="Visit our LinkedIn page"
                       >
                        <img className="icon" src={LinkedIn} alt="LinkedIn-logo"/>
                    </a>
                     <a 
                        href="https://www.instagram.com/oppotrain" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        aria-label="Visit our Instagram page"
                     >
                        <img className="icon" src={Instagram} alt="Instagram-logo"/>
                    </a>
                </div>
                <div className="copyright">©2026 Oppotrain LLC</div>
            </div>
        </div>);
}

export default Footer;
